import { c as _c } from "react/compiler-runtime";
import { CompetitionDetailLoading } from '@/components/social/competition/competition-boundaries';
export default function CompetitionLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CompetitionDetailLoading />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}